import {
  setIsTourModalOpenActionType,
  setIsTourRunningActionType,
  setTourStepActionType,
} from "./actionTypes";
import { createAction } from "@reduxjs/toolkit";

export const setIsTourModalOpen = createAction(
  setIsTourModalOpenActionType,
  (payload) => ({
    payload,
  }),
);

export const setIsTourRunning = createAction(
  setIsTourRunningActionType,
  (payload) => ({
    payload,
  }),
);

export const setTourStep = createAction(setTourStepActionType);
